<div class="side-bar">
    <div class="d-flex justify-content-between align-items-center pb-px-12">
        <mat-label class="fs-20 fw-7" *ngIf="title">{{title}}</mat-label>
        <div class="d-flex align-items-center">
            <div class="w-fit-content me-2">
                <app-tag
                    label="{{rowData.status == 1 ? 'Confirmée' : rowData.status == 2 ? 'À Valider' : rowData.status == 3 ? 'En cours' : 'Accepté automatiquement' }}"
                    [type]="rowData?.status"></app-tag>

            </div>
            <svg-icon (click)="onDialogClose()" src="/assets/icons/close-modal-primary.svg"
                class="cursor-pointer"></svg-icon>
        </div>
    </div>
    <!-- <mat-tab-group mat-stretch-tabs="{{false}}" mat-align-tabs="start" color="primary"> -->
    <!-- <mat-tab label="Details"> -->
    <div class="py-px-24" *ngIf="condidatFilted[0]">
        <app-text-separator text="Candidat"></app-text-separator>
    </div>
    <div class="card-container p-px-16 mb-px-24">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
                <app-user [text]="condidatFilted[0]?.name" [imageSrc]="condidatFilted[0]?.img"></app-user>
            </div>
            <div class="d-flex align-items-center">
                <app-button text="Voir profil" (click)="condidatProfil()" [stroked]="true" color="primary"
                    class="me-1"></app-button>
                <app-button text="Voir le contrat" [stroked]="true"></app-button>
            </div>
        </div>
    </div>
    <!-- <div class="card-container p-px-16 mb-px-24" *ngIf="rowData">
                    <div class="d-flex align-items-start">
                        <div>
                            <svg-icon src="/assets/icons/search-file.svg" [svgStyle]="{ 'width.px':24,'height.px':24 }"></svg-icon>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="fs-13 fw-4">En attente pour candidatures</span>
                            <span class="text-secondary fs-11 fw-4">La candidature pour cette mission sera automatiquement acceptée dès qu'un candidat aura été trouvé.</span>
                        </div>
                    </div>
                </div> -->
    <div class="pb-px-12">
        <app-text-separator text="Votre validation"></app-text-separator>
        <div class="d-flex py-px-24 align-items-center">
            <span class="fs-16 fw-3 text-neutral-dark me-4">Niveau de satisfaction</span>
            <app-rating (onClick)="rating($event)" [rating]="4" [readOnly]="true" [width]="28"
                [height]="28"></app-rating>

        </div>
    </div>
    <div class="pb-px-12">
        <app-text-separator text="Raison de non validation"></app-text-separator>
        <div class="d-flex py-px-24 align-items-center">
            <span class="fs-13 fw-4 text-neutral-dark">Le (La) candidat(e) a eu un problème de comportement grave ayant
                nécessité l’interruption de la mission.</span>
        </div>
    </div>
    <div class="pb-px-12">
        <app-text-separator text="Description"></app-text-separator>
        <p class="py-px-12 fs-13 fw-4">
            Description de la mission
            Recherche un analyste en biochimie passionné et expérimenté pour une mission temporaire de 12 jours. Vous
            serez responsable de mener des analyses approfondies sur des échantillons biologiques, d'interpréter les
            résultats et de produire des rapports détaillés. Cette mission implique également la collaboration avec une
            équipe multidisciplinaire pour contribuer à des projets de recherche novateurs dans le domaine de la
            biochimie.
        </p>
        <div class="drop-photo-area py-px-12">
            <img src="/assets/images/Image-1.png" />
            <img src="/assets/images/Image-2.png" />
            <img src="/assets/images/Image-3.png" />
            <img src="/assets/images/Image-4.png" />
        </div>
    </div>
    <!-- <div cclass="py-px-12">
                <app-text-separator text="état de la mission" textClass="w-px-200"></app-text-separator>
                <div class=" d-flex gap-4 py-px-12">
                    <div class="col card-container px-px-12 py-px-16 fs-16 fw-4" [ngClass]="{'disabled': condidatFilted[0]}">
                        Publiée 
                    </div>
                    <div class="col-6 card-container px-px-12 py-px-16 fs-16 fw-4" [ngClass]="{'disabled': condidatFilted[0]}">
                        <svg-icon src="/assets/icons/red-flag.svg"></svg-icon>
                        <span> Urgente</span>
                    </div>
                </div>
            </div>  -->
    <div class="py-px-12">
        <app-text-separator text="Général"></app-text-separator>
        <div class="py-px-12 d-flex">
            <div class="d-flex flex-column align-items-start">
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/secteur-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Secteur</span>
                        <span class="fs-16 fw-4">Laboratoire Pharmaceutique</span>
                    </div>
                </div>
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/speciality-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Poste</span>
                        <span class="fs-16 fw-4">Biochimiste</span>
                    </div>
                </div>
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/file-text-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Contrat</span>
                        <span class="fs-16 fw-4">Intérim</span>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column align-items-start  ms-4">
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/site-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Site</span>
                        <span class="fs-16 fw-4">NovaCare Paris</span>
                    </div>
                </div>
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/heart-beating-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Service d’affectation</span>
                        <span class="fs-16 fw-4">Bloc opératoire</span>
                    </div>
                </div>
                <div class="d-flex my-px-12">
                    <svg-icon src="/assets/icons/money-rounded.svg"></svg-icon>
                    <div class="d-flex flex-column ms-3">
                        <span class="fs-13 fw-4">Rémunération</span>
                        <span class="fs-16 fw-4">2 000,00 € /jour</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="py-px-12">
        <app-text-separator text="Date(s) et durée" textClass="w-px-140"></app-text-separator>
        <div class="py-px-12 d-flex justify-content-between">
            <div class="d-flex flex-column">
                <span class="fs-16 fw-4">12 jours</span>
            </div>
            <div class="d-flex flex-column">
                <span class="fs-13 fw-3">Début</span>
                <span class="fs-16 fw-4">10 Janvier 2024, 10:00</span>
            </div>
            <div class="d-flex flex-column">
                <span class="fs-13 fw-3">Fin</span>
                <span class="fs-16 fw-4">22 Janvier 2024, 20:00</span>
            </div>
        </div>

    </div>
    <div class="py-px-12 pb-px-100">
        <app-text-separator text="Prise en charge des frais de mission" textClass="w-px-260"></app-text-separator>
        <div class="py-px-12">
            <div class="d-flex mb-px-12">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <span class="fs-16 fw-4">Hébergement</span>
            </div>
            <div class="d-flex">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <span class="fs-16 fw-4">Repas</span>
            </div>
        </div>
        <div class="d-flex justify-content-end action-buttons">
            <app-button text="Archiver" [stroked]="true" srcIcon="/assets/icons/archive-primary.svg" color="primary"
                class="me-2"></app-button>
            <app-button text="Dupliquer" [stroked]="true" srcIcon="/assets/icons/copy-primary.svg" color="primary"
                class="me-2"></app-button>
            <app-button text="Modifier" [stroked]="true" srcIcon="/assets/icons/pencil-primary.svg" color="primary"
                class="me-2"></app-button>
        </div>
    </div>
    <!-- </mat-tab> -->
    <!-- <mat-tab label="Candidatures ({{condidat?.length ? condidat?.length: '0'}})">
            <app-mission-candidatures [condidat]="condidat" [condidatAccepted]="condidatAccepted" [condidatFilted]="condidatFilted"></app-mission-candidatures>
         </mat-tab>
    </mat-tab-group> -->
</div>